export default __webpack_public_path__ + "static/media/group4.6096549d.png";